<template lang="pug">
  b-card.w-100(no-body)
    div(slot="header") {{$t('management_page.account_security_policy')}}
    b-list-group
      b-list-group-item
        b-row
          b-col(cols="2") {{$t('management_page.password_complexity')}}
          b-col.d-flex.align-items-center(cols="10")
            b-form-radio-group.ml-2.ref(v-model="form.password_level" :options="levelOption" name="radio-size" stacked)
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="2") {{$t('function-settings01')}}
          b-col.d-flex.align-items-center(cols="10")
            b-form-input.w-10.d-inline-block(v-model="form.login_failure_limit", size="sm")
            //- span.ml-1 회
            span.ml-2 {{$t('auth_failure_num_desc')}}

      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="2") {{$t('password-expired')}}
          b-col.d-flex.align-items-center(cols="10")
            b-form-input.w-10.d-inline-block(v-model="form.password_change_limit", size="sm")
            //- span.ml-1 일
            span.ml-2 {{$t('password_expired_desc')}}

      b-list-group-item
        b-row
          b-col(cols="2") {{$t('self_unlock')}}
          b-col.d-flex.align-items-center(cols="10")
            switches.lmm-switch(
              v-model="form.self_unlock",
              theme="bootstrap",
              :color="form.self_unlock ? 'warning' : 'default'"
            )
            span.ml-2 {{$t('self_unlock_desc')}}
</template>

<script>
import Switches from "vue-switches"

export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Switches,
  },
  watch: {
    "form.flag_function_2fa"(val) {
      this.$emit("updateToggle", "flag_function_2fa", val)
    },
    "form.self_unlock"(val) {
      this.$emit("updateToggle", "self_unlock", val)
    },
  },
  data() {
    return {
      levelOption: [
        { value: "0", text: this.$t("password_level0") },
        { value: "1", text: this.$t("password_level1") },
        { value: "2", text: this.$t("password_level2") },
        { value: "3", text: this.$t("password_level3") },
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
